/* eslint-disable sonarjs/no-duplicate-string */
import { standardizeKey } from "./helpers/standardizer.helper";

export const CUSTOMIZATION_LABEL_TO_SECTION_METADATA_KEY = {
  "Attribution of Tracking Error": "AttributionOfTrackingError",
  "Coupon Cash Flow": "CashFlowProfile",
  Cover: "Cover",
  "Credit Quality": "CreditQuality",
  Definitions: "Definitions",
  Disclosures: "Disclosures",
  "ESG Rating": "ESGRating",
  "Firm Overview": "FirmOverview",
  "Interest Rate Analysis": "InterestRateAnalysis",
  "Key Rate Durations": "KeyRate",
  Maturity: "Maturity",
  "1-Sheeter Summary": "OneSheeterSummary",
  "Portfolio Characteristics": "PortfolioCharacteristics",
  "Proposed Portfolio": "Portfolio",
  "Proposed Sells": "ProposedSells",
  "Scenario Analysis": "ScenarioAnalysis",
  "Sectors GICS": "SectorsGICS",
  "Sectors Risk Exposure": "SectorsRiskExposure",
  Sectors: "Sectors",
  "State Exposure": "State",
  "Style Risk Exposure": "StyleRiskExposure",
  "Target Portfolio": "TargetPortfolio",
  "Transition Summary": "TransitionSummary",
};
//#endregion

//#region //! Sections metadata
//! Move all the usage from this object to MetadataService in remi-pdf and delete
//! all the usage from remi-app
export const SECTIONS_METADATA = {
  AttributionOfTrackingError: {
    // Identifiers
    sectionMetadataKey: "AttributionOfTrackingError",
    sectionKey: "Attribution of Tracking Error",
    sectionKeyKebab: "attribution-of-tracking-error",
    filename: "attributionOfTrackingError",
    // Data
    title: "Attribution of Tracking Error",
    subtitle: "",
    // Formatting and styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Attribution of Tracking Error",
      sectionMetadataKey: "AttributionOfTrackingError",
      sectionKeyKebab: "attribution-of-tracking-error",
    },
    chart1: {
      id: "report-attribution-of-tracking-error",
      containerId: "report-attribution-of-tracking-error",
      type: "bar",
      height: "230px",
      legendId: "legend-report-attribution-of-tracking-error",
      legendTitle: "Sources of Tracking Error",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Attribution of Tracking Error Data Table",
      tableRowHeaderKey: "Sources of Tracking Error",
    },
  },
  CashFlowProfile: {
    // Identifiers
    sectionMetadataKey: "CashFlowProfile",
    sectionKey: "Cash Flow Profile",
    sectionKeyKebab: "cash-flow-profile",
    filename: "couponCashFlow",
    // Data
    title: "Proposed Coupon Cash Flow Profile",
    subtitle: "",
    titleAlternative: "Proposed Coupon Cash Flow Profile",
    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Coupon Cash Flow",
      sectionMetadataKey: "CashFlowProfile",
      sectionKeyKebab: "cash-flow-profile",
    },
    chart1: {
      id: "report-coupon-cash-flow",
      containerId: "report-coupon-cash-flow",
      legendId: "legend-report-coupon-cash-flow",
      title: "Coupon Cash Flow",
      height: "230px",
      isReversed: false,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Cash Flow Profile Data Table",
      tableRowHeaderKey: "Month",
    },
  },
  Cover: {
    // Identifiers
    sectionMetadataKey: "Cover",
    sectionKey: "Cover",
    sectionKeyKebab: "cover",
    filename: "cover",
    // Data
    title: "Remi Cash Proposal",
    subtitle: "",
    titleAlternative: "Remi Transition Proposal",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Cover",
      sectionMetadataKey: "Cover",
      sectionKeyKebab: "cover",
    },
  },
  CreditQuality: {
    // Identifiers
    sectionMetadataKey: "CreditQuality",
    sectionKey: "Credit Quality",
    sectionKeyKebab: "credit-quality",
    filename: "creditQuality",
    // Data
    title: "Proposed Credit Quality",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Credit Quality",
      sectionMetadataKey: "CreditQuality",
      sectionKeyKebab: "credit-quality",
    },
    chart1: {
      id: "report-credit-quality",
      containerId: "report-credit-quality",
      legendId: "legend-report-credit-quality",
      type: "bar",
      height: "177px",
      legendTitle: "Credit Quality (by bucket)",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Credit Quality Data Table",
      tableRowHeaderKey: "Credit Quality (by bucket)",
    },
  },
  Definitions: {
    // Identifiers
    sectionMetadataKey: "Definitions",
    sectionKey: "Definitions",
    sectionKeyKebab: "definitions",
    filename: "definitions",
    // Data
    title: "Definitions",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Definitions",
      sectionMetadataKey: "Definitions",
      sectionKeyKebab: "definitions",
      options: {
        checked: true,
        readOnly: true,
        locked: true,
      },
    },
  },
  Disclosures: {
    // Identifiers
    sectionMetadataKey: "Disclosures",
    sectionKey: "Disclosures",
    sectionKeyKebab: "disclosures",
    filename: "disclosures",
    // Data
    title: "Disclosures",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Disclosures",
      sectionMetadataKey: "Disclosures",
      sectionKeyKebab: "disclosures",
      options: {
        checked: true,
        readOnly: true,
        locked: true,
      },
    },
  },
  ESGRating: {
    // Identifiers
    sectionMetadataKey: "ESGRating",
    sectionKey: "ESG Rating",
    sectionKeyKebab: "esg-rating",
    filename: "esgRating",
    // Data
    title: "ESG Rating",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "ESG Rating",
      sectionMetadataKey: "ESGRating",
      sectionKeyKebab: "esg-rating",
    },
    chart1: {
      id: "report-esg-ratings",
      containerId: "report-esg-ratings",
      legendId: "legend-report-esg-ratings",
      type: "bar",
      height: "330px",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "ESG Rating Data Table",
      tableRowHeaderKey: "ESG Rating (By Bucket)",
    },
  },
  FirmOverview: {
    // Identifiers
    sectionMetadataKey: "FirmOverview",
    sectionKey: "Firm Overview",
    sectionKeyKebab: "firm-overview",
    filename: "firmOverview",
    // Data
    title: "Firm Overview",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Firm Overview",
      sectionMetadataKey: "FirmOverview",
      sectionKeyKebab: "firm-overview",
    },
  },
  InterestRateAnalysis: {
    // Identifiers
    sectionMetadataKey: "InterestRateAnalysis",
    sectionKey: "Interest Rate Analysis",
    sectionKeyKebab: "interest-rate-analysis",
    filename: "interestRateSensitivityAnalysis",
    // Data
    title: "Interest Rate Sensitivity Analysis",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Interest Rate Analysis",
      sectionMetadataKey: "InterestRateAnalysis",
      sectionKeyKebab: "interest-rate-analysis",
    },
    chart1: {
      id: "report-interest-rate-analysis",
      containerId: "report-interest-rate-analysis",
      legendId: "legend-report-interest-rate-analysis",
      type: "bar",
      height: "",
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Interest Rate Analysis Data Table",
      tableRowHeaderKey: "Yield Change (bps)",
    },
  },
  KeyRate: {
    // Identifiers
    sectionMetadataKey: "KeyRate",
    sectionKey: "Key Rate",
    sectionKeyKebab: "key-rate",
    filename: "keyRateDurations",
    // Data
    title: "Proposed Key Rate Durations",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Key Rate Durations",
      sectionMetadataKey: "KeyRate",
      sectionKeyKebab: "key-rate",
    },
    chart1: {
      id: "report-key-rate-durations",
      containerId: "report-key-rate-durations",
      legendId: "legend-report-key-rate-durations",
      type: "bar",
      height: "230px",
      legendTitle: "Proposed Key Rate Durations",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Key Rate Data Table",
      tableRowHeaderKey: "Proposed Key Rate Durations",
    },
  },
  Maturity: {
    // Identifiers
    sectionMetadataKey: "Maturity",
    sectionKey: "Maturity",
    sectionKeyKebab: "maturity",
    filename: "maturity",
    // Data
    title: "Proposed Maturity",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Maturity",
      sectionMetadataKey: "Maturity",
      sectionKeyKebab: "maturity",
    },
    chart1: {
      id: "report-maturity",
      containerId: "report-maturity",
      legendId: "legend-report-maturity",
      type: "bar",
      height: "250px",
      legendTitle: "Maturity (by bucket)",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Maturity Data Table",
      tableRowHeaderKey: "Maturity (by bucket)",
    },
  },
  OneSheeterSummary: {
    // Identifiers
    sectionMetadataKey: "OneSheeterSummary",
    sectionKey: "1-Sheeter Summary",
    sectionKeyKebab: "one-sheeter",
    filename: "oneSheeterSummary",
    // Data
    title: "Proposal",
    subtitle: "",
    // Formatting and styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "1-Sheeter Summary",
      sectionMetadataKey: "OneSheeterSummary",
      sectionKeyKebab: "one-sheeter",
      options: {
        checked: true,
        readOnly: true,
        locked: true,
      },
    },
    chart1: {
      id: "report-one-sheeter-coupon-cash-flow",
      containerId: "report-one-sheeter-coupon-cash-flow",
      legendId: "legend-report-one-sheeter-coupon-cash-flow",
      title: "Coupon Cash Flow",
      type: "line",
      height: "230px",
      isReversed: false,
      isFullWidth: true,
    },
    chart2: {
      id: "report-one-sheeter-sectors-gics",
      containerId: "report-one-sheeter-sectors-gics",
      legendId: "legend-report-one-sheeter-sectors-gics",
      title: "Sectors (GICS®)[1]",
      type: "bar",
      height: "280px",
      isReversed: true,
    },
    chart3: {
      id: "report-one-sheeter-attribution-tracking-error",
      containerId: "report-one-sheeter-attribution-tracking-error",
      legendId: "legend-report-one-sheeter-attribution-tracking-error",
      title: "Attribution of Tracking Error",
      type: "bar",
      height: "180px",
      legendTitle: "Sources of Tracking Error",
      isReversed: true,
    },
  },
  PortfolioCharacteristics: {
    // Identifiers
    sectionMetadataKey: "PortfolioCharacteristics",
    sectionKey: "Portfolio Characteristics",
    sectionKeyKebab: "portfolio-characteristics",
    filename: "portfolioCharacteristics",
    // Data
    title: "Proposed Portfolio Characteristics",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Portfolio Characteristics",
      sectionMetadataKey: "PortfolioCharacteristics",
      sectionKeyKebab: "portfolio-characteristics",
    },
    table1: {
      tableCaption: "Portfolio Characteristics Data Table",
      tableRowHeaderKey: "Portfolio Characteristics",
    },
  },
  Portfolio: {
    // Identifiers
    sectionMetadataKey: "Portfolio",
    sectionKey: "Portfolio",
    sectionKeyKebab: "portfolio",
    filename: "proposedPortfolio",
    // Data
    title: "Target Portfolio",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "max",
    customizations: {
      label: "Proposed Portfolio",
      sectionMetadataKey: "Portfolio",
      sectionKeyKebab: "portfolio",
    },
    table1: {
      tableCaption: "Portfolio Data Table",
      tableRowHeaderKey: "Security Code",
    },
  },
  ProposedSells: {
    // Identifiers
    sectionMetadataKey: "ProposedSells",
    sectionKey: "Proposed Sells",
    sectionKeyAlternative: "Proposed Sell",
    sectionKeyKebab: "proposed-sells",
    filename: "proposedSells",
    // Data
    title: "Proposed Sells",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "max",
    customizations: {
      label: "Proposed Sells",
      sectionMetadataKey: "ProposedSells",
      sectionKeyKebab: "proposed-sells",
    },
    table1: {
      tableCaption: "Proposed Sells Data Table",
      tableRowHeaderKey: "CUSIP",
    },
  },
  ScenarioAnalysis: {
    // Identifiers
    sectionMetadataKey: "ScenarioAnalysis",
    sectionKey: "Scenario Analysis",
    sectionKeyKebab: "scenario-analysis",
    filename: "scenarioAnalysis",
    // Data
    title: "Scenario Analysis",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Scenario Analysis",
      sectionMetadataKey: "ScenarioAnalysis",
      sectionKeyKebab: "scenario-analysis",
    },
    chart1: {
      id: "report-scenario-analysis",
      containerId: "report-scenario-analysis",
      legendId: "legend-report-scenario-analysis",
      type: "bar",
      height: "230px",
      isReversed: false,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Scenario Analysis Data Table",
      tableRowHeaderKey: "Scenario Name",
    },
  },
  Sectors: {
    // Identifiers
    sectionMetadataKey: "Sectors",
    sectionKey: "Sector",
    sectionKeyKebab: "sectors",
    filename: "sectors",
    // Data
    title: "Proposed Sectors",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Sectors",
      sectionMetadataKey: "Sectors",
      sectionKeyKebab: "sectors",
    },
    chart1: {
      id: "report-sector",
      containerId: "report-sector",
      legendId: "legend-report-sector",
      type: "bar",
      height: "330px",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Sector Data Table",
      tableRowHeaderKey: "Sectors",
    },
  },
  SectorsGICS: {
    // Identifiers
    sectionMetadataKey: "SectorsGICS",
    sectionKey: "Sectors (GICS)",
    sectionKeyKebab: "sectors-gics",
    filename: "sectorsGICS",
    // Data
    title: "Sectors (GICS®)",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: true,
    variation: "stylized",
    customizations: {
      label: "Sectors GICS",
      sectionMetadataKey: "SectorsGICS",
      sectionKeyKebab: "sectors-gics",
    },
    chart1: {
      id: "report-sectors-gics",
      containerId: "report-sectors-gics",
      legendId: "legend-report-sectors-gics",
      type: "bar",
      height: "250px",
      isFullWidth: true,
      isReversed: true,
    },
    table1: {
      tableCaption: "Sectors (GICS) Data Table",
      tableRowHeaderKey: "Sectors",
    },
  },
  SectorsRiskExposure: {
    // Identifiers
    sectionMetadataKey: "SectorsRiskExposure",
    sectionKey: "Sectors (Risk Exposure)",
    sectionKeyKebab: "sectors-risk-exposure",
    filename: "sectorsRiskExposure",
    // Data
    title: "Sectors (Risk Exposure)",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: true,
    variation: "stylized",
    customizations: {
      label: "Sectors Risk Exposure",
      sectionMetadataKey: "SectorsRiskExposure",
      sectionKeyKebab: "sectors-risk-exposure",
    },
    chart1: {
      id: "report-sectors-risk-exposure",
      containerId: "report-sectors-risk-exposure",
      legendId: "legend-report-sectors-risk-exposure",
      type: "bar",
      height: "250px",
      isFullWidth: true,
      isReversed: true,
    },
    table1: {
      tableCaption: "Sectors (Risk Exposure) Data Table",
      tableRowHeaderKey: "Sectors",
    },
  },
  State: {
    // Identifiers
    sectionMetadataKey: "State",
    sectionKey: "State",
    sectionKeyKebab: "state",
    filename: "stateExposure",
    // Data
    title: "Proposed State Exposure",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "State Exposure",
      sectionMetadataKey: "State",
      sectionKeyKebab: "state",
    },
    table1: {
      tableCaption: "State Data Table",
      tableRowHeaderKey: "State Exposure",
    },
  },
  StyleRiskExposure: {
    // Identifiers
    sectionMetadataKey: "StyleRiskExposure",
    sectionKey: "Style (Risk Exposure)",
    sectionKeyKebab: "style-risk-exposure",
    filename: "styleRiskExposure",
    // Data
    title: "Style Risk Exposure",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: true,
    variation: "stylized",
    customizations: {
      label: "Style Risk Exposure",
      sectionMetadataKey: "StyleRiskExposure",
      sectionKeyKebab: "style-risk-exposure",
    },
    table1: {
      tableCaption: "Style (Risk Exposure) Data Table",
      tableRowHeaderKey: "Style Risks",
    },
  },
  TargetPortfolio: {
    // Identifiers
    sectionMetadataKey: "TargetPortfolio",
    sectionKey: "Target Portfolio*",
    sectionKeyKebab: "target-portfolio",
    filename: "targetPortfolio",
    // Data
    title: "Target Portfolio",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "max",
    customizations: {
      label: "Target Portfolio",
      sectionMetadataKey: "TargetPortfolio",
      sectionKeyKebab: "target-portfolio",
    },
    table1: {
      tableCaption: "Target Portfolio Data Table",
      tableRowHeaderKey: "Ticker",
    },
  },
  TransitionSummary: {
    // Identifiers
    sectionMetadataKey: "TransitionSummary",
    sectionKey: "Transition Summary",
    sectionKeyKebab: "transition-summary",
    filename: "transitionSummary",
    // Data
    title: "Transition Summary",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Transition Summary",
      sectionMetadataKey: "TransitionSummary",
      sectionKeyKebab: "transition-summary",
    },
    table1: {
      tableCaption: "Transition Summary Data Table",
      tableRowHeaderKey: "",
    },
    chart1: {
      id: "report-transition-summary",
      containerId: "report-transition-summary",
      legendId: "legend-report-transition-summary",
      type: "bar",
      height: "230px",
      isReversed: false,
      isFullWidth: true,
    },
  },
};
//#endregion

//#region //! Report metadata utilities per ReportType and AssetType
export const SECTORS_SECTION_TYPES = {
  "Sectors (GICS)": "SectorsGICS",
  "Sectors (Risk Exposure)": "SectorsRiskExposure",
  Sector: "Sectors",
};

//! ATTENTION! Don't change the order, some places depends on this order.
export const AVAILABLE_SECTIONS_PER_REPORT_METADATA = {
  cash: {
    corp: [
      SECTIONS_METADATA.FirmOverview.customizations,
      SECTIONS_METADATA.OneSheeterSummary.customizations,
      SECTIONS_METADATA.Portfolio.customizations,
      SECTIONS_METADATA.PortfolioCharacteristics.customizations,
      SECTIONS_METADATA.CashFlowProfile.customizations,
      SECTIONS_METADATA.Maturity.customizations,
      SECTIONS_METADATA.CreditQuality.customizations,
      SECTIONS_METADATA.ESGRating.customizations,
      SECTIONS_METADATA.KeyRate.customizations,
      SECTIONS_METADATA.Sectors.customizations,
      SECTIONS_METADATA.InterestRateAnalysis.customizations,
      SECTIONS_METADATA.ScenarioAnalysis.customizations,
      SECTIONS_METADATA.Definitions.customizations,
      SECTIONS_METADATA.Disclosures.customizations,
    ],
    equity: [
      SECTIONS_METADATA.FirmOverview.customizations,
      SECTIONS_METADATA.OneSheeterSummary.customizations,
      SECTIONS_METADATA.PortfolioCharacteristics.customizations,
      SECTIONS_METADATA.AttributionOfTrackingError.customizations,
      SECTIONS_METADATA.SectorsGICS.customizations,
      SECTIONS_METADATA.SectorsRiskExposure.customizations,
      SECTIONS_METADATA.StyleRiskExposure.customizations,
      SECTIONS_METADATA.TargetPortfolio.customizations,
      SECTIONS_METADATA.Definitions.customizations,
      SECTIONS_METADATA.Disclosures.customizations,
    ],
    muni: [
      SECTIONS_METADATA.FirmOverview.customizations,
      SECTIONS_METADATA.OneSheeterSummary.customizations,
      SECTIONS_METADATA.Portfolio.customizations,
      SECTIONS_METADATA.PortfolioCharacteristics.customizations,
      SECTIONS_METADATA.CashFlowProfile.customizations,
      SECTIONS_METADATA.Maturity.customizations,
      SECTIONS_METADATA.CreditQuality.customizations,
      SECTIONS_METADATA.KeyRate.customizations,
      SECTIONS_METADATA.Sectors.customizations,
      SECTIONS_METADATA.State.customizations,
      SECTIONS_METADATA.InterestRateAnalysis.customizations,
      SECTIONS_METADATA.ScenarioAnalysis.customizations,
      SECTIONS_METADATA.Definitions.customizations,
      SECTIONS_METADATA.Disclosures.customizations,
    ],
    tbill: [
      SECTIONS_METADATA.FirmOverview.customizations,
      SECTIONS_METADATA.OneSheeterSummary.customizations,
      SECTIONS_METADATA.Portfolio.customizations,
      SECTIONS_METADATA.PortfolioCharacteristics.customizations,
      SECTIONS_METADATA.Maturity.customizations,
      SECTIONS_METADATA.CreditQuality.customizations,
      SECTIONS_METADATA.InterestRateAnalysis.customizations,
      SECTIONS_METADATA.ScenarioAnalysis.customizations,
      SECTIONS_METADATA.Definitions.customizations,
      SECTIONS_METADATA.Disclosures.customizations,
    ],
    treasury: [
      SECTIONS_METADATA.FirmOverview.customizations,
      SECTIONS_METADATA.OneSheeterSummary.customizations,
      SECTIONS_METADATA.Portfolio.customizations,
      SECTIONS_METADATA.PortfolioCharacteristics.customizations,
      SECTIONS_METADATA.CashFlowProfile.customizations,
      SECTIONS_METADATA.Maturity.customizations,
      SECTIONS_METADATA.CreditQuality.customizations,
      SECTIONS_METADATA.KeyRate.customizations,
      SECTIONS_METADATA.InterestRateAnalysis.customizations,
      SECTIONS_METADATA.ScenarioAnalysis.customizations,
      SECTIONS_METADATA.Definitions.customizations,
      SECTIONS_METADATA.Disclosures.customizations,
    ],
  },
  transition: {
    corp: [
      SECTIONS_METADATA.FirmOverview.customizations,
      SECTIONS_METADATA.OneSheeterSummary.customizations,
      SECTIONS_METADATA.TransitionSummary.customizations,
      SECTIONS_METADATA.PortfolioCharacteristics.customizations,
      SECTIONS_METADATA.CashFlowProfile.customizations,
      SECTIONS_METADATA.Maturity.customizations,
      SECTIONS_METADATA.CreditQuality.customizations,
      SECTIONS_METADATA.ESGRating.customizations,
      SECTIONS_METADATA.KeyRate.customizations,
      SECTIONS_METADATA.Sectors.customizations,
      SECTIONS_METADATA.ProposedSells.customizations,
      SECTIONS_METADATA.InterestRateAnalysis.customizations,
      SECTIONS_METADATA.ScenarioAnalysis.customizations,
      SECTIONS_METADATA.Definitions.customizations,
      SECTIONS_METADATA.Disclosures.customizations,
    ],
    equity: [
      SECTIONS_METADATA.FirmOverview.customizations,
      SECTIONS_METADATA.OneSheeterSummary.customizations,
      SECTIONS_METADATA.TransitionSummary.customizations,
      SECTIONS_METADATA.PortfolioCharacteristics.customizations,
      SECTIONS_METADATA.AttributionOfTrackingError.customizations,
      SECTIONS_METADATA.SectorsGICS.customizations,
      SECTIONS_METADATA.SectorsRiskExposure.customizations,
      SECTIONS_METADATA.StyleRiskExposure.customizations,
      SECTIONS_METADATA.ProposedSells.customizations,
      SECTIONS_METADATA.Definitions.customizations,
      SECTIONS_METADATA.Disclosures.customizations,
    ],
    muni: [
      SECTIONS_METADATA.FirmOverview.customizations,
      SECTIONS_METADATA.OneSheeterSummary.customizations,
      SECTIONS_METADATA.TransitionSummary.customizations,
      SECTIONS_METADATA.PortfolioCharacteristics.customizations,
      SECTIONS_METADATA.CashFlowProfile.customizations,
      SECTIONS_METADATA.Maturity.customizations,
      SECTIONS_METADATA.CreditQuality.customizations,
      SECTIONS_METADATA.KeyRate.customizations,
      SECTIONS_METADATA.Sectors.customizations,
      SECTIONS_METADATA.State.customizations,
      SECTIONS_METADATA.ProposedSells.customizations,
      SECTIONS_METADATA.InterestRateAnalysis.customizations,
      SECTIONS_METADATA.ScenarioAnalysis.customizations,
      SECTIONS_METADATA.Definitions.customizations,
      SECTIONS_METADATA.Disclosures.customizations,
    ],
    treasury: [
      SECTIONS_METADATA.FirmOverview.customizations,
      SECTIONS_METADATA.KeyRate.customizations,
      SECTIONS_METADATA.OneSheeterSummary.customizations,
      SECTIONS_METADATA.ProposedSells.customizations,
      SECTIONS_METADATA.TransitionSummary.customizations,
      SECTIONS_METADATA.InterestRateAnalysis.customizations,
      SECTIONS_METADATA.PortfolioCharacteristics.customizations,
      SECTIONS_METADATA.ScenarioAnalysis.customizations,
      SECTIONS_METADATA.CashFlowProfile.customizations,
      SECTIONS_METADATA.Definitions.customizations,
      SECTIONS_METADATA.Maturity.customizations,
      SECTIONS_METADATA.Disclosures.customizations,
      SECTIONS_METADATA.CreditQuality.customizations,
    ],
    tbill: [],
  },
};
//#endregion

//#region //! Constants
export const OTHER_STATES_TEXT = "Other States";
export const ENABLE_OUTPUT_REPORT_CUSTOMIZER = true;
export const OUTPUT_REPORT_CUSTOMIZE_LOOP_INITIAL_SECONDS = 60;
export const OUTPUT_REPORT_CUSTOMIZE_LOOP_EXTRA_TIME = 240;
export const PROPOSED_SELLS_CHAR_COUNT = 44;
export const REPORT_DATA_INDEXING = {
  transition: {
    equity: {
      "Transition Summary": [
        "Full Liquidation of Pre-Existing Portfolio",
        "Minimize Tax Liability",
        "Balance Tax Liability & Tracking Error",
        "Minimize Tracking Error",
      ],
    },
  },
};
export const DATATABLE_SCENARIO_COLUMNS = [
  "Minimize Tax Liability",
  "Balance Tax Liability & Tracking Error",
  "Minimize Tracking Error",
  "Target Portfolio",
];
export const DATATABLE_HIGHLIGHT_COLUMNS = [
  "Maintain and Reinvest Proceeds",
  "Existing Portfolio (Maintain & Reinvest Proceeds)",
  "Existing Portfolio",
];
//#endregion

//#region //! Utilitary functions
//! Move all the usage from these functions to ReportDataService and delete
//! these functions from remi-app
export const getStandardizedLabels = ({ referenceLabels }) => {
  return Object.entries(referenceLabels).reduce((acc, [label, override]) => {
    return { ...acc, [standardizeKey(label)]: { label, override } };
  }, {});
};
export const getFormattedChartLabels = ({ referenceLabels, labels }) => {
  const standardizedLabels = getStandardizedLabels({ referenceLabels });
  return labels.map((label) => {
    if (Array.isArray(label)) return label;
    const standardizedReference = standardizedLabels[standardizeKey(label)];
    return (
      standardizedReference?.override || standardizedReference?.label || label
    );
  });
};
//#endregion

export const BASE_LABEL_SUB_SECTIONS = {
  "Balance Tax Liability & Tracking Error": [
    "Balance Tax",
    "Liability &",
    "Tracking Error",
  ],
  Benchmark: null,
  "Change in Market Value ($)": ["Change in", "Market Value ($)"],
  "Effective Duration": ["Effective", "Duration"],
  "Existing Portfolio": ["Existing", "Portfolio"],
  "Full Liquidation of Pre-existing Portfolio": [
    "Full Liquidation",
    "of Pre-existing",
    "Portfolio",
  ],
  "Initial Funding Amount": ["Initial Funding Amount"],
  "Maintain and Reinvest Proceeds": ["Maintain and", "Reinvest", "Proceeds"],
  "Market Value ($)": null,
  "Minimize Tax Liability": ["Minimize Tax", "Liability"],
  "Minimize Tracking Error": ["Minimize Tracking", "Error"],
  Model: null,
  "Reference Index": ["Reference", "Index"],
  "Target Portfolio": ["Target", "Portfolio"],
  "Total Return (%)": ["Total", "Return (%)"],
  "Transition Scenario": ["Transition", "Scenario"],
  "Transition Scenarios": ["Transition", "Scenarios"],
  "Transition To Remi": ["Transition", "To Remi"],
  "Yield to Worst": null,
};

//! ATTENTION! Don't change the order, some places depends on this order.
//#region //! Report Cash
export const CASH_CORP_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Proposed Portfolio",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "ESG Rating",
  "Key Rate Durations",
  "Sectors",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const CASH_EQUITY_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Portfolio Characteristics",
  "Attribution of Tracking Error",
  "Sectors GICS",
  "Sectors Risk Exposure",
  "Style Risk Exposure",
  "Target Portfolio",
  "Definitions",
  "Disclosures",
];

export const CASH_MUNI_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Proposed Portfolio",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "Key Rate Durations",
  "Sectors",
  "State Exposure",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const CASH_TBILL_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Proposed Portfolio",
  "Portfolio Characteristics",
  "Maturity",
  "Credit Quality",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const CASH_TREASURY_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Proposed Portfolio",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "Key Rate Durations",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

//#endregion

//! ATTENTION! Don't change the order, some places depends on this order.
//#region //! Report transition
export const TRANSITION_CORP_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Transition Summary",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "ESG Rating",
  "Key Rate Durations",
  "Sectors",
  "Proposed Sells",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const TRANSITION_EQUITY_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Transition Summary",
  "Portfolio Characteristics",
  "Attribution of Tracking Error",
  "Sectors GICS",
  "Sectors Risk Exposure",
  "Style Risk Exposure",
  "Proposed Sells",
  "Definitions",
  "Disclosures",
];

export const TRANSITION_MUNI_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Transition Summary",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "Key Rate Durations",
  "Sectors",
  "State Exposure",
  "Proposed Sells",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

//#endregion

export const AVAILABLE_SECTIONS_LIST_PER_REPORT = {
  cash: {
    corp: CASH_CORP_CUSTOMIZATION_LABELS,
    equity: CASH_EQUITY_CUSTOMIZATION_LABELS,
    muni: CASH_MUNI_CUSTOMIZATION_LABELS,
    treasury: CASH_TREASURY_CUSTOMIZATION_LABELS,
    tbill: CASH_TBILL_CUSTOMIZATION_LABELS,
  },
  transition: {
    corp: TRANSITION_CORP_CUSTOMIZATION_LABELS,
    equity: TRANSITION_EQUITY_CUSTOMIZATION_LABELS,
    muni: TRANSITION_MUNI_CUSTOMIZATION_LABELS,
    treasury: [],
    tbill: [],
  },
};

export const REQUIRED_SECTIONS = [
  "Cover",
  "1-Sheeter Summary",
  "Definitions",
  "Disclosures",
];

export const ONE_SHEETER_SUMMARY_SECTIONS = [
  "1-Sheeter Summary",
  "Portfolio Characteristics",
  "Attribution of Tracking Error",
  "Coupon Cash Flow",
  "Sectors GICS",
];

export const ONE_SHEETER_SUMMARY_REQUIRED_SECTIONS = {
  cash: {
    corp: ["Portfolio Characteristics", "Coupon Cash Flow"],
    equity: [
      "Portfolio Characteristics",
      "Attribution of Tracking Error",
      "Sectors GICS",
    ],
    muni: ["Portfolio Characteristics", "Coupon Cash Flow"],
    tbill: ["Portfolio Characteristics"],
    treasury: ["Portfolio Characteristics", "Coupon Cash Flow"],
  },
  transition: {
    corp: ["Portfolio Characteristics", "Coupon Cash Flow"],
    equity: [
      "Portfolio Characteristics",
      "Attribution of Tracking Error",
      "Sectors GICS",
    ],
    muni: ["Portfolio Characteristics", "Coupon Cash Flow"],
    tbill: [],
    treasury: [],
  },
};

export const DEFAULT_LABELS_PER_SECTION_KEY = {
  "Attribution of Tracking Error": {
    "Attribution of Tracking Error": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    "Target Portfolio": "Target Portfolio[1]",
    //#endregion

    //#region Fields
    Total: null,

    "Sector Risk": null,
    "Specific Risk": null,
    "Style Risk": null,
    //#endregion
  },
  "Coupon Cash Flow": {
    "Proposed Coupon Cash Flow Profile": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    "% Yearly Income": null,
    "% of Par Value": null,
    Income: null,
    //#endregion
  },
  Cover: {
    Cover: null,

    //#region Fields
    "Advisor Email": null,
    Advisor: null,
    "Asset Type": null,
    Client: null,
    "Credit Quality": null,
    "Initial Funding Amount": null,
    "Inserted By": null,
    "Maturity Range": null,
    "Report Date": null,
    "Report Type": null,
    ReportId: null,
    "Sector Exclusions": null,
    "State Exclusions": null,
    "State Preference": null,
    Strategy: null,
    TransitionId: null,
    DisplayCustomizations: null,
    //#endregion
  },
  "Credit Quality": {
    "Credit Quality": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Cash: null,
    Total: null,

    A: null,
    AA: null,
    AAA: null,
    B: null,
    BB: null,
    BBB: null,
    C: null,
    CC: null,
    CCC: null,
    D: null,
    NR: null,
    //#endregion
  },
  "ESG Rating": {
    "ESG Rating": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Cash: null,
    Total: null,

    A: null,
    AA: null,
    AAA: null,
    B: null,
    BB: null,
    BBB: null,
    CCC: null,
    NR: null,
    //#endregion
  },
  "Interest Rate Analysis": {
    "Interest Rate Sensitivity Analysis": null,
    "Interest Rate Analysis": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion
  },
  "Key Rate Durations": {
    "Key Rate Durations": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Cash: null,
    Total: null,

    "0-1 year": null,
    "1-2 year": null,
    "2-5 year": null,
    "5-10 year": null,
    "10-20 year": null,
    "20 year plus": null,
    //#endregion
  },
  Maturity: {
    Maturity: null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Cash: null,
    Total: null,

    // Months
    "0-1 month": null,
    "1-2 months": null,
    "2-3 months": null,
    "3-4 months": null,
    "4-5 months": null,
    "5-6 months": null,
    "6-7 months": null,
    "7-8 months": null,
    "8-9 months": null,
    "9-10 months": null,
    "10-11 months": null,
    "11-12 months": null,
    "12+ months": null,

    // Year singular
    "0-1 year": null,
    "1-2 year": null,
    "2-3 year": null,
    "3-4 year": null,
    "3-5 year": null,
    "4-5 year": null,
    "5-6 year": null,
    "5-10 year": null,
    "6-7 year": null,
    "7-8 year": null,
    "8-9 year": null,
    "9-10 year": null,
    "10-11 year": null,
    "10-15 year": null,
    "11-15 year": null,
    "15-20 year": null,
    "20 year plus": null,

    // Years plural
    "1-2 years": null,
    "2-3 years": null,
    "3-4 years": null,
    "4-5 years": null,
    "5-6 years": null,
    "6-7 years": null,
    "7-8 years": null,
    "8-9 years": null,
    "9-10 years": null,
    "10-11 years": null,
    "11-15 years": null,
    "15-20 years": null,
    "20 years plus": null,
    //#endregion
  },
  "Portfolio Characteristics": {
    "Portfolio Characteristics": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    "% Callable": null,
    "% of Market Value in Stocks": null,
    "Average Weighted Market Cap (Billions $)": null,
    "Avg Daily Trading Vol (Millions $)": null,
    "Beginning Tracking Error": null,
    "Beta to Benchmark": null,
    "Beta to Index": null,
    "Coupon Income (Next 12 months)": null,
    "Coupon Income (Next 12 months)⁴": null,
    "Coupon Income (Next 6 months)": null,
    Coupon: null,
    "Credit Quality": null,
    "Defensive Sectors (%)": null,
    "Diversification Ratio": null,
    "Dividend Yield": null,
    "Duration Times Spread (DTS)": null,
    "Effective Duration (OAD)": null,
    "Tracking Error": null,
    "ESG Rating": null,
    "Highly Cyclical Sectors (%)": null,
    "Large Cap (%)": null,
    "Liquidity Score (LQA)": null,
    "Mid Cap (%)": null,
    "Moderately Cyclical Sectors (%)": null,
    "Number of Securities": null,
    "Option Adjusted Spread (OAS)": null,
    "Option Adjusted Spread Duration (OASD)": null,
    Price: null,
    "Small Cap (%)": null,
    "Time to Maturity": null,
    "Tracking Error to Benchmark": null,
    "Weight in Top Ten Holdings (%)": null,
    "Yield to Maturity": null,
    "Yield to Worst": null,
    //#endregion
  },
  "Proposed Portfolio": {
    "Proposed Portfolio": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Cash: null,
    Total: null,

    Beta: null,
    Callable: null,
    Coupon: null,
    "Credit Quality": null,
    DTS: null,
    "Effective Duration": null,
    Issuer: null,
    "Market Value": null,
    "Maturity Date": null,
    OAS: null,
    OASD: null,
    "Par Value": null,
    Price: null,
    Sector: null,
    State: null,
    Weight: null,
    "Yield to Worst": null,
    //#endregion
  },
  "Proposed Sells": {
    "Proposed Sells": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Balanced: null,
    "Cost Basis (USD)": null,
    Country: null,
    Coupon: null,
    "Credit Quality": null,
    CUSIP: null,
    "Dividend Yield (%)": null,
    "Effective Duration": null,
    "Market Value (USD)": null,
    "Market Value": null,
    "Maturity Date": null,
    "Min Tax Liability": null,
    "Min Tracking Error": null,
    "Purchase Date": null,
    "Quantity/Units": null,
    Sector: null,
    "Security Name": null,
    "Security Type": null,
    Units: null,
    "Weight (%)": null,
    "Yield to Worst": null,
    //#endregion
  },
  "Scenario Analysis": {
    "Scenario Analysis": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion
  },
  Sectors: {
    Sectors: null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Cash: null,
    Total: null,

    Banking: null,
    "Basic Industry": null,
    "Brokerage/Asset Managers/Exchanges": null,
    "Capital Goods": null,
    Communications: null,
    "Consumer Cyclical": null,
    "Consumer Non Cyclical": null,
    Education: null,
    Electric: null,
    Energy: null,
    "Finance Companies": null,
    "Financial Other": null,
    Hospital: null,
    Housing: null,
    "IDR/PCR": null,
    "Industrial Other": null,
    Insurance: null,
    Lease: null,
    "Local GO": null,
    "Natural Gas": null,
    "Non Corporates": null,
    "Non Municipals": null,
    Other: null,
    REITS: null,
    "Resource & Recovery": null,
    "Special Tax": null,
    "State GO": null,
    Technology: null,
    Transportation: null,
    Utilities: null,
    "Utility Other": null,
    "Water & Sewer": null,
    //#endregion
  },
  "Sectors GICS": {
    "Sectors (GICS®)": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Cash: null,
    Total: null,

    "Communication Services": null,
    "Consumer Discretionary": null,
    "Consumer Staples": null,
    Energy: null,
    Financials: null,
    "Health Care": null,
    Industrials: null,
    "Information Technology": null,
    Materials: null,
    NaN: null,
    Other: null,
    "Real Estate": null,
    Utilities: null,
    //#endregion
  },
  "Sectors Risk Exposure": {
    "Sectors Risk Exposure": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Total: null,

    "Communication Services": null,
    "Consumer Discretionary": null,
    "Consumer Staples": null,
    Energy: null,
    Financials: null,
    "Health Care": null,
    Industrials: null,
    "Information Technology": null,
    Materials: null,
    "Real Estate": null,
    Utilities: null,
    //#endregion
  },
  "State Exposure": {
    "State Exposure": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    "Other States": null,
    Cash: null,
    Total: null,

    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: null,
    Colorado: null,
    Connecticut: null,
    Delaware: null,
    "District of Columbia": null,
    Florida: null,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: null,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": null,
    "Non Municipals": null,
    "North Carolina": null,
    "North Dakota": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: null,
    Utah: null,
    Vermont: null,
    "Virgin Islands": null,
    Virginia: null,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
    //#endregion
  },
  "Style Risk Exposure": {
    "Sectors Risk Exposure": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Total: null,

    "US Beta": null,
    "US Dividend Yield": null,
    "US Earnings Quality": null,
    "US Growth": null,
    "US Leverage": null,
    "US Management Quality": null,
    "US Mid Capitalization": null,
    "US Momentum": null,
    "US Profitability": null,
    "US Prospect": null,
    "US Residual Volatility": null,
    "US Size": null,
    "US Value": null,
    //#endregion
  },
  "Target Portfolio": {
    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    Country: null,
    "Dividend Yield (%)": null,
    "Market Value (USD)": null,
    Price: null,
    Sector: null,
    "Security Name": null,
    "Security Type": null,
    Units: null,
    "Weight (%)": null,
    //#endregion
  },
  "Transition Summary": {
    "Transition Summary": null,

    //#region Subsections
    ...BASE_LABEL_SUB_SECTIONS,
    //#endregion

    //#region Fields
    "Beginning Tracking Error": null,
    Buys: null,
    "Cash Raised": null,
    "Cash To Raise": null,
    "Cost Basis": null,
    "Ending Tracking Error": null,
    "Full Liquidation Tax Cost": null,
    "Initial Portfolio Market Value": null,
    "Initial Portfolio Value Excluding Accrued Interest": null,
    "Initial Portfolio Value Including Accrued Interest": null,
    "Long Term Proposed Realized Gains": null,
    "Long Term Proposed Realized Losses": null,
    "Long Term Tax Rate": null,
    "Long Term Unrealized Gains": null,
    "Long Term Unrealized Losses": null,
    "Long Term": null,
    "Long-Term Tax Rate": null,
    "Net Realized Gains/Losses": null,
    "No. Securities Bought": null,
    "No. Securities Sold (all/part)": null,
    "Number of Holdings": null,
    "Number Of Holdings": null,
    "Potential Transition Tax Savings": null,
    "Proposed Realized Gains": null,
    "Proposed Realized Losses": null,
    "Proposed Turnover": null,
    Sells: null,
    "Short Term Proposed Realized Gains": null,
    "Short Term Proposed Realized Losses": null,
    "Short Term Tax Rate": null,
    "Short Term Unrealized Gains": null,
    "Short Term Unrealized Losses": null,
    "Short Term": null,
    "Short-Term Tax Rate": null,
    "Tracking Error": null,
    "Transition Tax Cost": null,
    "Unrealized Gains": null,
    "Unrealized Losses": null,
    //#endregion
  },
};
//#endregion
